import styled from 'styled-components';

export const UserAbsenceWrapper = styled.div`
  & > div:first-child {
    margin-bottom: 0;
  }

  & > div > div:last-child {
    margin-right: 0;
  }
`;

export const TagWrapper = styled.div`
  & > div:first-child {
    margin-right: 10px;
  }
`;
